import { queryOptions } from '@tanstack/react-query'
import getApiResponseData from '@utils/get-api-response-data'

import { api } from '../api'
import { key } from './key'

const DAY_IN_MS = 24 * 60 * 60 * 1000

export const serviceOptions = () =>
  queryOptions({
    queryKey: key('service-options'),
    queryFn: async () => {
      // Сотня — предел сервера и заведомо больше всего справочника (на 20.08.2026 в нём 16
      // услуг). Просить обязательно: без этого довода сервер отдаёт только первые десять.
      const { data } = await api.serviceOptions({ limit: 100 })

      // Пустой список отдаём как есть: на боевом сервере поддержка может ещё не завести услуги, и
      // это законное состояние. Отказ сервера сюда не дойдёт — он придёт отдельным признаком.
      return getApiResponseData(data)?.services ?? []
    },
    // Перечень неизменный: одного повтора хватает для редкого сбоя, а дальнейшие только задерживают отказ.
    retry: 1,
    staleTime: DAY_IN_MS,
    gcTime: DAY_IN_MS,
  })
